import { useState } from 'react';
import InitFilters from '../../constants/InitFilteringContanct';
const DEFAULT_GRANT_DATA_TYPE = 'cellphoneNumber';

const useCustomHook = () => {
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [filters, setFilters] = useState(InitFilters());
  const [userContactInfo, setUserContactInfo] = useState(null);
  const [isNewDialogOpen, setIsNewDialogOpen] = useState(false);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [itemIdToDelete, setItemIdToDelete] = useState(null); // id of item to delete
  const [currentId, setCurrentId] = useState(null);
  const [grantUserDataType, setGrantUserDataType] = useState(DEFAULT_GRANT_DATA_TYPE);
  const [incomingUserQuery, setIncomingUserQuery] = useState(null);
  const [shebaNumber, setShebaNumber] = useState(null);
  const [shebaName, setShebaName] = useState(null);
  const [page, setPage] = useState(0);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);


  return {
    firstName, setFirstName,
    lastName, setLastName,
    grantUserDataType, setGrantUserDataType,
    isLoading,
    setIsLoading,
    list,
    setList,
    isSubmitting,
    setIsSubmitting,
    setFilterParams,
    size,
    setSize,
    filters,
    setFilters,
    isNewDialogOpen,
    setIsNewDialogOpen,
    confirmDeleteModal,
    setConfirmDeleteModal,
    itemIdToDelete,
    setItemIdToDelete,
    currentId,
    setCurrentId,
    shebaNumber,
    setShebaNumber,
    shebaName,
    setShebaName,
    page,
    setPage,
    incomingUserQuery, setIncomingUserQuery,
    userContactInfo, setUserContactInfo
  };
};

export default useCustomHook;
